/**
 * Shared lucide-react icon map for the Help Center. Help section/category configs
 * reference icons by string name; this resolves them to components.
 */
import {
  LayoutDashboard,
  CheckSquare,
  Users,
  ShoppingCart,
  BarChart3,
  FolderOpen,
  Settings,
  Keyboard,
  BookOpen,
  Lightbulb,
  TrendingUp,
  AlertCircle,
  Ticket,
  Rocket,
  Route,
  Star,
  MessageCircleQuestion,
  Sparkles,
  HelpCircle,
  LineChart,
  FileSignature,
} from 'lucide-react'

export type HelpIcon = React.ComponentType<{ className?: string }>

export const helpIconMap: Record<string, HelpIcon> = {
  Lightbulb,
  Rocket,
  LayoutDashboard,
  CheckSquare,
  Ticket,
  Users,
  ShoppingCart,
  Route,
  BarChart3,
  FolderOpen,
  TrendingUp,
  Settings,
  Keyboard,
  BookOpen,
  Star,
  MessageCircleQuestion,
  Sparkles,
  AlertCircle,
  HelpCircle,
  // Sales Trackers, matching the icon the nav band uses.
  LineChart,
  // Contract reviews, matching its nav item.
  FileSignature,
}

/** Resolve an icon name to a component, falling back to a generic help icon. */
export function resolveHelpIcon(name: string): HelpIcon {
  return helpIconMap[name] ?? HelpCircle
}
